/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/webAnalytics.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/home/award-finder/web-analytics.js
**/

var WebAnalytics = {};

WebAnalytics = (function() {
    var serializedForm = null;

	function addWebAnalyticsFieldsToSerializedForm(form) {
		serializedForm = form.serializeObject();
		var tripType = '';
		if (serializedForm['roundTrip'] === 'true') {
			tripType = 'RoundTrip';
		} else {
			tripType = 'OneWay';
		}
		var carrierPreference ='';
		if (serializedForm['includePartners'] === 'true') {
			carrierPreference = 'AA,AE,AAConnection,OneWorld';
		} else {
			carrierPreference = 'AA,AE,AAConnection';
		}
		serializedForm['v_origin'] = serializedForm['origin'];
		serializedForm['departureDay'] = $("#departOnInput").datepicker("getDate").getDate();
		serializedForm['departureMonth'] = $("#departOnInput").datepicker("getDate").getMonth()+1;
		serializedForm['v_destination'] = serializedForm['category'];
		serializedForm['v_flightSearch'] = 'Award';
		serializedForm['v_awardType'] = 'AwardFinder';
		serializedForm['v_searchFeature'] = 'AwardFinder';
		serializedForm['v_passengerCount'] = serializedForm['pax'];
		serializedForm['v_tripType'] = tripType;
		serializedForm['v_carrierPreference'] = carrierPreference;
		serializedForm['v_cabinOfServicePreference'] = serializedForm['cabin'];
		serializedForm['v_awardFinderMileageTarget'] = stripCommas(serializedForm['miles']);
		serializedForm['v_event'] = 'AwardFinderSearch';
		return serializedForm;
	}

	function addWebAnalyticsFieldsAndSerialize(form) {
		serializedForm = addWebAnalyticsFieldsToSerializedForm(form);
		serializedForm['v_awardFinderResultSet'] = SearchUtil.getNumberOfResults();
		return mapToURLString(serializedForm);
	}

	function mapToURLString(map) {
		var URLString = $.param(map);
		return URLString;
	}

	function stripCommas(str) {
		return str.replace(/,/g, ''); // strip commas
	}

	$.fn.serializeObject = function()
	{
	    var o = {};
	    var a = this.serializeArray();
	    $.each(a, function() {
	        if (o[this.name] !== undefined) {
	            if (!o[this.name].push) {
	                o[this.name] = [o[this.name]];
	            }
	            o[this.name].push(this.value || '');
	        } else {
	            o[this.name] = this.value || '';
	        }
	    });
	    return o;
	};

	return {
		addWebAnalyticsFieldsAndSerialize: addWebAnalyticsFieldsAndSerialize,
		addWebAnalyticsFieldsToSerializedForm: addWebAnalyticsFieldsToSerializedForm
	};


}());
